module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('p', {
    staticClass: "page-container"
  }, [_vm._v("无访问权限")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-04af4dc6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Authority.vue
// module id = 1306
// module chunks = 1